/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const DIRECT_UPLOAD_MUTATION = gql`
  mutation tenantDirectUploadNoId( $file: [TenantDirectUploadCreateInput!] ) {
    tenant {
      directUpload( create: $file ) {
        metadata {
          url
          headers
          blobId
          signedBlobId
        }
        errors
      }
    }
  }
`;

export const DIRECT_UPLOAD_RECOGNITION_RESPONSE_MUTATION = gql`
  mutation tenantDirectUploadRecognitionResponseNoId( $file: [TenantDirectUploadCreateInput!] ) {
    tenant {
      directUpload( create: $file, recognition: true ) {
        metadata {
          url
          headers
          blobId
          signedBlobId
          recognition {
            url
            headers
            body
          }
        }
        errors
      }
    }
  }
`;
